module.exports = "pegasus_template/assets/theme3/twitter-icon-1.png";